module.exports = __webpack_public_path__ + "static/s-4-66514905e83e6ea8eceb0a70121a8f0d.svg";